import { createContext, useContext } from 'react';

export const BusinessDashboardContext = createContext(null);
export const useDashboard = () => useContext(BusinessDashboardContext);
